import { BoxTheme, PREMIUM_THEMES } from '@lub0v/santa-utils';
import { isSeason } from '@src/theme/season';
const keyFor = (boxKey: string) => `ss:deferred-theme:${boxKey}`;
export type DeferredTheme = { userId: number; theme: BoxTheme; ready: boolean; at: number };
export function readDeferredTheme(boxKey: string, userId: number): DeferredTheme | null {
  try {
    const value = JSON.parse(localStorage.getItem(keyFor(boxKey)) || 'null');
    if (value?.userId === userId && PREMIUM_THEMES.includes(value.theme) && isSeason(value.theme) &&
      typeof value.ready === 'boolean' && value.at <= Date.now() && Date.now() - value.at < 7 * 86400000) return value;
  } catch { /* Browser storage is optional. */ }
  return null;
}
export function clearDeferredTheme(boxKey: string) {
  try { localStorage.removeItem(keyFor(boxKey)); } catch { /* Browser storage is optional. */ }
}
export function saveDeferredTheme(boxKey: string, userId: number, theme: BoxTheme) {
  try { localStorage.setItem(keyFor(boxKey), JSON.stringify({ userId, theme, ready: false, at: Date.now() })); }
  catch { /* Browser storage is optional. */ }
}
export function completeDeferredTheme(boxKey: string, userId: number) {
  const saved = readDeferredTheme(boxKey, userId);
  if (!saved) return;
  try { localStorage.setItem(keyFor(boxKey), JSON.stringify({ ...saved, ready: true })); }
  catch { /* Browser storage is optional. */ }
}
